import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'

const isProd = import.meta.env.MODE === 'production'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  // 100% des transactions tracées — réduire à 0.2 en production si trop de volume
  tracesSampleRate: isProd ? 0.2 : 1.0,
  // Replay session uniquement en production (enregistre les clics/actions lors d'une erreur)
  replaysSessionSampleRate: isProd ? 0.1 : 0,
  replaysOnErrorSampleRate: isProd ? 1.0 : 0,
  integrations: isProd
    ? [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ]
    : [],
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2>Oups, une erreur est survenue 😕</h2>
          <p>L'équipe a été alertée automatiquement. Rechargez la page pour continuer.</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: '1rem', padding: '0.5rem 1.5rem', cursor: 'pointer' }}>
            Recharger
          </button>
        </div>
      }
      showDialog
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>
)
